import React from 'react';
import { withBasicDetails } from '../../base/components/WithBasicDetails';
import { routeMappings } from '../../constants';
import { withNoAuthentication } from './WithNoAuthentication';

const SocialSignOnConfirm = React.lazy(() => import('../../authentication/components/SocialSignOnConfirm'));
const LoginPage = React.lazy(() => import('../../authentication/components/LoginPage'));
const ForgotPasswordPage = React.lazy(() => import('../../authentication/components/ForgotPasswordPage'));
const ResetPasswordPage = React.lazy(() => import('../../authentication/components/ResetPasswordPage'));
const UserProfile = React.lazy(() => import('../../authentication/components/UserProfile'));

const authenticationRoutes = [
  {
    path: routeMappings['LOGIN'],
    exact: true,
    component: withNoAuthentication(LoginPage),
  },
  {
    path: routeMappings['SSO'],
    exact: true,
    component: withBasicDetails(SocialSignOnConfirm),
  },
  {
    path: routeMappings['FORGOT_PASSWORD'],
    exact: true,
    component: withNoAuthentication(ForgotPasswordPage),
  },
  {
    path: routeMappings['RESET_PASSWORD'],
    exact: true,
    component: ResetPasswordPage,
  },
  {
    path: routeMappings['USER_PROFILE'],
    exact: true,
    component: withBasicDetails(UserProfile),
  },
];

export default authenticationRoutes;
